
export function log () {
  // nativeLog(arguments)
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/logger/index.js